import { Suspense, useMemo } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';

import RootLayout from '../layouts/rootLayout';
import type { DeploySurface } from '../lib/deploySurface';
import RouteSkeleton from './components/RouteSkeleton';
import { adminManifestRoutes } from './manifests/routes.admin';
import { customerManifestRoutes } from './manifests/routes.customer';
import { driverManifestRoutes } from './manifests/routes.driver';
import { ownerManifestRoutes } from './manifests/routes.owner';
import { websiteManifestRoutes } from './manifests/routes.website';
import { RouteFallback } from './manifests/routeCommon';

const manifestForSurface = (surface: DeploySurface): RouteObject[] => {
  switch (surface) {
    case 'customer':
      return customerManifestRoutes;
    case 'driver':
      return driverManifestRoutes;
    case 'admin':
      return adminManifestRoutes;
    case 'owner':
      return ownerManifestRoutes;
    case 'website':
    default:
      return websiteManifestRoutes;
  }
};

export const createSurfaceRouter = (surface: DeploySurface) =>
  createBrowserRouter([
    {
      path: '/',
      element: <RootLayout />,
      children: manifestForSurface(surface)
    }
  ]);

type AppRouterProps = {
  surface: DeploySurface;
};

export function SurfaceAppRouter({ surface }: AppRouterProps) {
  const router = useMemo(() => createSurfaceRouter(surface), [surface]);
  return (
    <Suspense fallback={<RouteFallback />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}
